// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `section .container {
  max-width: 70%;
}

.container .inner-container .card-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 2em;
}

.card-container .card-about {
  border-bottom: 3px solid #ffa559;
  border-top: 1px solid #dee2e6;
  border-left: 1px solid #dee2e6;
  border-right: 1px solid #dee2e6;
}

.container .flow-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.flow-card:hover {
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  transform: scale(1.02);
  transition: 0.3s ease-in;
}

@media (max-width: 890px) {
  section .container {
    max-width: 90%;
  }
  .container .inner-container .card-container {
    display: flex;
    flex-wrap: wrap;
  }

  .container .flow-container {
    flex-wrap: wrap;
  }
}

@media (max-width: 580px) {
  section .container {
    max-width: 90%;
  }
  .container .inner-container .card-container {
    display: flex;
    flex-wrap: wrap;
  }

  .container .flow-container {
    flex-wrap: wrap;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/about.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iDAAiD;EACjD,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["section .container {\n  max-width: 70%;\n}\n\n.container .inner-container .card-container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 2em;\n}\n\n.card-container .card-about {\n  border-bottom: 3px solid #ffa559;\n  border-top: 1px solid #dee2e6;\n  border-left: 1px solid #dee2e6;\n  border-right: 1px solid #dee2e6;\n}\n\n.container .flow-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n}\n\n.flow-card:hover {\n  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;\n  transform: scale(1.02);\n  transition: 0.3s ease-in;\n}\n\n@media (max-width: 890px) {\n  section .container {\n    max-width: 90%;\n  }\n  .container .inner-container .card-container {\n    display: flex;\n    flex-wrap: wrap;\n  }\n\n  .container .flow-container {\n    flex-wrap: wrap;\n  }\n}\n\n@media (max-width: 580px) {\n  section .container {\n    max-width: 90%;\n  }\n  .container .inner-container .card-container {\n    display: flex;\n    flex-wrap: wrap;\n  }\n\n  .container .flow-container {\n    flex-wrap: wrap;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
